import React, { useMemo, useCallback } from 'react';
import { createEditor } from 'slate';
import { Slate, Editable, withReact } from 'slate-react';
import { RichTextEditorElement } from "./RichTextEditor_Element";
import { Leaf } from "./RichTextEditor_Leaf";
export const RichTextViewer = _ref => {
  let {
    value
  } = _ref;
  const editor = useMemo(() => withReact(createEditor()), []);
  const renderElement = useCallback(props => {
    return /*#__PURE__*/React.createElement(RichTextEditorElement, props);
  }, []);
  const renderLeaf = useCallback(props => {
    return /*#__PURE__*/React.createElement(Leaf, props);
  }, []);
  return /*#__PURE__*/React.createElement(Slate, {
    editor: editor,
    value: value,
    onChange: () => {}
  }, /*#__PURE__*/React.createElement(Editable, {
    readOnly: true,
    renderLeaf: renderLeaf,
    renderElement: renderElement
  }));
};